<template>
    <div id="Inventory">
        <div class="">
            <!-- Component Start -->
            <h1 class="text-lg text-red-400 font-medium">Your Account Overview </h1>
            <div class="buy-now cursor-pointer"  v-on:click="displayResponsive = true">
                + Add Inventory
            </div>
            <Dialog header="Header" v-model:visible="displayResponsive" :breakpoints="{'960px': '80vw'}"  :style="{width: '50vw'}">
	            
                <div>
                <Dropdown v-model="form.blood_type" :options="bloodType" optionValue="value" optionLabel="name" placeholder="Select a Bloodtype" />

         
            <div class="p-field flex m-1 flex-col p-col-12 p-md-3">
                <label for="currency-ng">Available Stock</label>
                <InputNumber  id="minmax" v-model="form.available_stock" mode="decimal" :min="1" :max="1000" />
            </div>
            <div class="p-field flex m-1 flex-col p-col-12 p-md-3">
                <label for="currency-ng">Price</label>
                <InputNumber id="withoutgrouping" v-model="form.blood_price" mode="decimal" :useGrouping="false" />
            </div>
            <div class="buy-now cursor-pointer"  @click="addInventory()">
                + Add Inventory
            </div>
                </div>
            </Dialog>
            <div class="container ">
                <div class="py-8">
                    <div>
                        <h2 class="text-2xl font-semibold leading-tight">Inventory Record</h2>
                    </div>
                    <div class="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
                        <div class="inline-block min-w-full shadow-md rounded-lg overflow-hidden">
                            <table class="min-w-full leading-normal">
                                <thead>
                                    <tr>
                                        <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                            Blood
                                        </th>
                                        <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                            Stock
                                        </th>
                                        <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                            Sold
                                        </th>
                                        <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                            Price
                                        </th>
                                        <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                     <inventoryProduct @add = 'increase' @del = 'drop' :inventory = 'inventory' :index = 'index' v-for="(inventory, index) in inventories"
                                    :key="index" />
                                   
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="my-width mt-6">
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="shadow overflow-hidden sm:rounded-lg"><ScrollPanel style="width: 100%; height: calc(100vh - 20em)" class="custom">
                            <table class="min-w-full text-sm text-red-500"> 
                                <thead class="rounded-t-lg  sm text-xs uppercase font-medium">
                                    <tr>
                                        <th></th>
                                        <th
                                            scope="col"
                                            class="px-6 py-3 text-left tracking-wider"
                                        >
                                            Blood
                                            </th>
                                            <th
                                                scope="col"
                                                class="px-6 py-3 text-left tracking-wider"
                                            >
                                                Stock
                                                </th>
                                                <th
                                                    scope="col"
                                                    class="px-6 py-3 text-left tracking-wider"
                                                >
                                                    Sold
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="px-6 py-3 text-left tracking-wider"
                                                    >
                                                        Price
                                                        </th>
                                                       
                                                                <th
                                                                    scope="col"
                                                                    class="px-6 py-3 text-left tracking-wider"
                                                                >
                                                                   
                                                                    </th>
                                    </tr>
                                </thead>
                                <tbody class="bg-white">
                                   
                                    <inventoryProduct :inventory = 'inventory' :index = 'index' v-for="(inventory, index) in inventories"
                                    :key="index" />
                                   
                                </tbody> 
                            </table></ScrollPanel>
                        </div>
                    </div>
                </div>
               
            </div> -->
    <!-- Component End <img class="w-4 fill-current text-green-600" :src="imgType"/> -->

</template>
<script>
import InputNumber from 'primevue/inputnumber';
import {mapActions} from 'vuex'
import axios from "axios";
import Dialog from 'primevue/dialog'
import Dropdown from 'primevue/dropdown';
import ScrollPanel from "primevue/scrollpanel";
import InventoryProduct from "../components/Inventory-product.vue";
export default {
  name: "Dash",
  data() {
    return {
      inventories: [],
      notifications: [],
      showModal: false,
      
      form: {
        blood_type: "",
        blood_price: 0,
        available_stock: 1
      },
      bloodType: [
                {name: 'A+', img:'APlus.svg' , value: 'a positive'},
                {name: 'B+', img:'BMinus.svg' , value: 'b positive'},
                {name: 'A-', img:'AMinus.svg' , value: 'a negative'},
                {name: 'B-', img:'BMinus.svg' , value: 'b negative'},
                {name: 'O+', img:'OPlus.svg' , value: 'o positive'},
                {name: 'O-', img:'OMinus.svg' , value: 'o negative'},
                {name: 'AB+', img:'ABPlus.svg' , value: 'ab positive'},
                {name: 'AB-', img:'ABMinus.svg' , value: 'ab negative'},
                
            ],
      displayResponsive: false,
      display: false
    };
  },
  computed: {
    
  },
  methods: {
    ...mapActions({
            delInventory: 'inventory/delInventory'
           
        }),

    drop(id){
     console.log('am here ' + id)
            var data = { "blood_qty": -1 }

            var config = {
                method: 'patch',
                url: `https://bloodhq-be.herokuapp.com/api/v1/inventories/record/stock-up/${id}`,
                headers: {
                    'Accept': 'application/json',
                },
                data: data
            };

            axios(config)
                .then((response) => {
                  this.$toast.add({
                  severity: "success",
                  detail: JSON.stringify(response.data.message),
                  life: 3000
                });
                this.getInventory();
                    
                })
                .catch(function(error) {
                    console.log(error);
                });
        
    },
    increase(id){
     console.log('am here ' + id)
            var data = { "blood_qty": +1 }

            var config = {
                method: 'patch',
                url: `https://bloodhq-be.herokuapp.com/api/v1/inventories/record/stock-up/${id}`,
                headers: {
                    'Accept': 'application/json',
                },
                data: data
            };

            axios(config)
                .then((response) => {
                  this.$toast.add({
                  severity: "success",
                  detail: JSON.stringify(response.data.message),
                  life: 3000
                });
                this.getInventory();
                    
                })
                .catch(function(error) {
                    console.log(error);
                });
        
    },
    addInventory() {
      axios
        .post("/bloods/addblood", this.form, {
          headers: {
            Accept: "application/json"
          }
        })
        .then(response => {
          this.showModal = false;
          this.$toast.add({
            severity: "success",
            detail: " Record created successfully",
            life: 3000
          });
          this.getInventory();
          
        })
        .catch(
          this.$toast.add({
            severity: "error",
            detail: "an error occured, Blood Type has been added already",
            life: 3000
          })
        );
    },
    async getInventory() {
      await axios
        .get("/inventories", {
          headers: {
            Accept: "application/json"
          }
        })
        .then(
            res => (this.inventories = res.data.data)
            
        )
        .catch(err =>
          this.$toast.add({
            severity: "error",
            detail: "an error occured, please contact the admin",
            life: 3000
          })
        );
    }
  },
  computed: {},
  components: {
    InventoryProduct,
    ScrollPanel,
    Dialog,
    Dropdown,
    InputNumber
   
  },
  mounted() {
    this.isSpin = true;
    // this.isAuthenticated();
    this.getInventory();
    // this.getNotification();
  }
};
</script>
<style lang="scss" scoped>
.my-width {
  width: 60%;
}
.buy-now {
  background-color: #ed6755;
  border: none;
  margin: 1em 0;
  border-radius: 5px;
  width: 200px;
  padding: 14px;
  font-size: 16px;
  color: white;
  text-align: center;
  box-shadow: 0px 6px 18px -5px rgba(237, 103, 85, 1);
}
.p-button {
    margin: 0.3rem .5rem;
    min-width: 10rem;
}

p {
    margin: 0;
}

.confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
}
.p-dropdown {
    min-width: 170px;
    border-radius: 1.6em;
    padding: 0 .5em;
    border-color: #ed6755;

}
.p-dropdown:hover .p-dropdown:focus {
  border-color: #ed6755;
  outline: none;
}
.p-dialog .p-button {
    min-width: 6rem;
}
</style>
